<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Cash Transfer Via Bank" disabled placeholder="Cash Transfer Via Bank" single-line
                    solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                <fieldset>
                  <legend>Deposit to</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" :md="currencyAmount ? 6 : 12">
                <fieldset>
                  <legend>
                    Amount in (USD)
                    <small v-if="minTransactionUSD > 0" class="ms-2 text-muted">
                      (Min: $ {{ minTransactionUSD }})
                    <=====>
                      (INR Rate: ₹ {{ depositAmount* this.bankCash[0]?.inr_rate || 0 }})
                    </small>
                  </legend>
                  <v-text-field :min="minTransactionUSD > 0 ? minTransactionUSD : 1" v-model="depositAmount" label="$"
                    type="number" single-line solo hide-details class="custom-select" :rules="amountRules"
                    :error="errors.amount" :error-messages="amountErrorMessages"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" v-if="currencyAmount" :md="currencyAmount ? 6 : 12">
                <fieldset>
                  <legend>USD To {{ this.currency.name }}</legend>
                  <v-text-field v-model="currencyAmount" label="usd to Other" single-line solo hide-details readonly
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" md="6">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-text-field :value="this.bankCash[0]?.beneficiary_bank_name" single-line solo hide-details readonly
                    label="Bank Name" class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" md="6">
                <fieldset>
                  <legend>Account name</legend>
                  <v-text-field :value="this.bankCash[0]?.beneficiary_name" label="Bank Account Name" single-line solo
                    hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" md="6">
                <fieldset>
                  <legend>Bank Account Number</legend>
                  <v-text-field :value="this.bankCash[0]?.beneficiary_account" label="Bank Account Number" single-line
                    solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" md="6">
                <fieldset>
                  <legend>Bank Address</legend>
                  <v-text-field :value="this.bankCash[0]?.beneficiary_bank_address" label="Bank Address" single-line
                    solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" md="12" v-if="needSlip == 1">
                <div class="input-file">
                  <span>Upload Bank Slip</span>
                  <v-file-input v-model="bankSlip" label="Choose file" filled prepend-icon="mdi-file-image"
                    hide-details></v-file-input>
                </div>
              </v-col>

              <v-col cols="12">
                <v-btn type="submit" @click.prevent="handleSubmit" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block" color="greenMain" :loading="loading"
                  :disabled="loading || !isFormValid">
                  Deposit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 rounded-0 deposit-form-card mt-2"
            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon color="greenMain">mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }}</span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>

            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      minTransactionUSD: 0,
      selectedAccount: null,
      depositAmount: "",
      currencyAmount: "",
      bankSlip: null,
      loading: false,
      errors: { amount: false },
      currency: { rate: 1, name: "USD", symbol: "$", color: "#fff" },
      options: {
        chart: { type: "line", toolbar: { show: false } },
        xaxis: { labels: { show: false }, axisTicks: { show: false }, axisBorder: { show: false } },
        yaxis: { labels: { show: false } },
        grid: { show: false },
        stroke: { width: 2 },
        dataLabels: { enabled: false },
        colors: ["#3A648E"],
      },
      series: [{ name: "Series 1", data: [45, 52, 38, 45, 19, 23, 2] }],
    };
  },

  computed: {
    ...mapState("deposit", ["methods", "accounts", "bankCash", "needSlip"]),
    
    isFormValid() {
      const amt = parseFloat(this.depositAmount);
      const isAmountValid = Number.isFinite(amt) && amt > 0 && (!this.minTransactionUSD || amt >= this.minTransactionUSD);
      const isBankSlipValid = this.needSlip !== 1 || this.bankSlip !== null;
      return isAmountValid && isBankSlipValid;
    },

    amountRules() {
      return [
        (v) => !!v || "Amount is required",
        (v) => parseFloat(v) > 0 || "Amount must be greater than 0",
        (v) =>
          !this.minTransactionUSD ||
          parseFloat(v) >= this.minTransactionUSD ||
          `Minimum deposit is $${this.minTransactionUSD}`,
      ];
    },

    amountErrorMessages() {
      const amt = parseFloat(this.depositAmount);
      if (!this.errors.amount) return [];
      if (!this.depositAmount || !Number.isFinite(amt) || amt <= 0) return ["Amount is required"];
      if (this.minTransactionUSD && amt < this.minTransactionUSD) return [`Minimum deposit is $${this.minTransactionUSD}`];
      return ["Invalid amount"];
    },

    formattedAccounts() {
      return this.accounts.map((account) => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account,
      }));
    },

    selectedAccountDetails() {
      return this.accounts.find((acc) => acc.trading_account_no === this.selectedAccount);
    },
  },

  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS,
      DEPOSITMETHODS__ACTIONS.BROKERSBANKCASH,
      DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSITCASH,
      DEPOSITMETHODS__ACTIONS.NEEDSLIP,
    ]),

    pickMinTransactionFromMethods() {
      try {
        if (!this.payment_id || !Array.isArray(this.methods)) return;

        const method =
          this.methods.find(
            (m) =>
              String(m.id) === String(this.payment_id) ||
              String(m.payment_id) === String(this.payment_id) ||
              String(m.payment_settings_id) === String(this.payment_id)
          ) || null;

        const min =
          method?.payment_settings?.min_transaction ??
          method?.min_transaction ??
          method?.minTransaction ??
          0;

        this.minTransactionUSD = Number(min) || 0;
      } catch (e) {
        this.minTransactionUSD = 0;
      }
    },

    handleAccountChange() {
      const account_details = this.accounts.find((acc) => acc.trading_account_no === this.selectedAccount);
      this.depositAmount = "";
      this.currencyAmount = "";
      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        const amount = parseFloat(this.depositAmount);
        if (!Number.isFinite(amount) || amount <= 0) {
          this.loading = false;
          return toast.error("Please enter a valid deposit amount");
        }
        if (this.minTransactionUSD && amount < this.minTransactionUSD) {
          this.loading = false;
          return toast.error(`Minimum deposit is $${this.minTransactionUSD}`);
        }
        const transactionId = "#cash" + Date.now() + "#bank";
        const formData = new FormData();
        formData.append("trading_account_no", this.selectedAccount);
        formData.append("amount", this.depositAmount);
        formData.append("transaction_id", transactionId);
        formData.append("payment_slip", this.bankSlip);
        formData.append("bank_id", this.bankCash[0]?.id);
        formData.append("bank_account_no", this.bankCash[0]?.beneficiary_account);
        formData.append("payment_id", this.payment_id);
        await this[DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSITCASH](formData);
      } catch (error) {
        console.error("Deposit submission error:", error.message);
      } finally {
        this.loading = false;
        this.resetForm();
      }
    },

    resetForm() {
      this.depositAmount = "";
      this.bankSlip = null;
      this.errors = { amount: false };
    },
  },

  async created() {
    this.payment_id = this.$route.query.payment_id;
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS]();
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]();
    await this[DEPOSITMETHODS__ACTIONS.BROKERSBANKCASH]();
    await this[DEPOSITMETHODS__ACTIONS.NEEDSLIP]();
    this.pickMinTransactionFromMethods();
  },
};
</script>

<style>
.text-muted {
  opacity: 0.7;
}
</style>